<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Believing Scientist</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="PT"><a href="#/xhtml/contents#pt001" id="pt-001">SCIENCE VERSUS RELIGION?</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?f49fad48